/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    saveHartiPrice,
};

async function saveHartiPrice(bulkModel) {
    const response = await CommonPost('/api/HartiPrice/SaveHartiPriceBulk', null, bulkModel);
    return response;
}